import React from "react";

const P0_BADGE_WIDTH = 16;
const P0_BADGE_HEIGHT = 12;

/** Shared P0 logomark badge used to denote preset (P0-provided) monitors. */
export const P0Badge: React.FC<{ className?: string }> = ({
  className = "shrink-0 opacity-60",
}) => (
  <img
    src="/p0-small-logomark-dark.svg"
    alt="P0"
    width={P0_BADGE_WIDTH}
    height={P0_BADGE_HEIGHT}
    className={className}
  />
);

/** Width-matched spacer for aligning rows without a P0 badge. */
export const P0BadgeSpacer: React.FC = () => (
  <span className="inline-block w-4 shrink-0" />
);
